import { camelCase } from 'es-toolkit';
import { Table } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';
import { getTableColumns } from '.';

export const DEFAULT_LEADS_PER_PAGE = 10;

const SkeletonCell = () => (
  <SkeletonContainer>
    <Bone css={{ marginBlock: 'tight' }} />
  </SkeletonContainer>
);

const SkeletonRow = ({ cellCount }: { cellCount: number }) => (
  <Table.Row>
    {Array.from({ length: cellCount }, (_, index) => (
      <Table.Cell key={index}>
        <SkeletonCell />
      </Table.Cell>
    ))}
  </Table.Row>
);

type LeadManagementTableSkeletonProps = {
  numberOfRows?: number;
  showHeader?: boolean;
  showSourceColumn?: boolean;
};

export default function LeadManagementTableSkeleton({
  numberOfRows,
  showHeader = true,
  showSourceColumn = false,
}: LeadManagementTableSkeletonProps) {
  const SKELETON_ROWS = Array(numberOfRows || DEFAULT_LEADS_PER_PAGE).fill('');
  const tableColumns = getTableColumns(showSourceColumn);

  return (
    <Table.Root aria-label="Leads" appearance="horizontal" size="lg">
      {showHeader && (
        <Table.Header>
          <Table.Row>
            {tableColumns.map((name) => {
              const colId = camelCase(name);
              return (
                <Table.HeaderCell key={colId} css={{ paddingLeft: name === 'Name' ? '75px' : '' }}>
                  {name}
                </Table.HeaderCell>
              );
            })}
          </Table.Row>
        </Table.Header>
      )}

      <Table.Body>
        {SKELETON_ROWS.map((_, index) => (
          <SkeletonRow key={index} cellCount={tableColumns.length} />
        ))}
      </Table.Body>
    </Table.Root>
  );
}
